"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function Standards() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const features = [{
    number: "01",
    title: "CERTIFIED EXPERTISE",
    description: "26 years of licensed, bonded, and insured environmental testing experience across South Florida."
  }, {
    number: "02",
    title: "CLINICAL PRECISION",
    description: "Advanced air quality sampling and surface testing protocols that meet the highest industry standards."
  }, {
    number: "03",
    title: "RAPID RESPONSE",
    description: "Serving Dade, Broward, and West Palm counties with fast, reliable, and actionable inspection reports."
  }, {
    number: "04",
    title: "EVIDENCE-FORWARD",
    description: "Detailed, data-backed documentation designed to provide clarity and peace of mind for your property."
  }];
  return <section data-section-id="2720" id="our-core-standards" ref={sectionRef} className="bg-background text-foreground py-24 md:py-36 lg:py-44 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div className={`lg:col-span-7 relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative rounded-lg" style={{
            boxShadow: "16px 16px 0 0 hsl(223 83% 9%)"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/mold_inspection_lab_testing.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/mold_inspection_lab_testing.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/mold_inspection_lab_testing.png-wvc-sizes" alt="Professional mold inspector conducting environmental testing in a residential setting" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-[4/5] rounded-lg" />
              {}
              <div className="absolute top-0 left-0 flex items-center gap-2 p-4 md:p-6">
                <span className="inline-block w-2 h-2 bg-primary" />
                <span className="font-mono text-[10px] md:text-xs tracking-[0.2em] uppercase text-white bg-primary px-2 py-1 rounded-md">
                  Certified / Licensed
                </span>
              </div>
            </div>
          </div>

          {}
          <div className={`lg:col-span-5 lg:pt-4 transition-all duration-1000 delay-150 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="flex items-center gap-3 mb-8">
              <span className="inline-block w-8 h-px bg-primary" />
              <p className="font-mono text-xs md:text-sm tracking-[0.25em] uppercase text-primary">
                03 / Our Core Standards
              </p>
            </div>

            {}
            <h2 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold leading-[0.95] tracking-tight mb-4">
              Clinical
              <br />
              <span className="font-serif italic font-light text-primary">
                Trust.
              </span>
            </h2>

            <p className="font-default text-base md:text-lg text-muted-foreground leading-relaxed mb-12 max-w-md">
              MYB Services delivers evidence-based environmental testing, ensuring your home or business remains a safe, healthy environment.
            </p>

            {}
            <div className="flex flex-col">
              <Separator className="bg-border" />
              {features.map((feature, i) => <div key={feature.number} data-index={i} className="group cursor-default">
                  <div className="flex items-start gap-5 md:gap-7 py-6 md:py-7 transition-all duration-300 ease-out group-hover:pl-1">
                    {}
                    <div className="shrink-0">
                      <span className="font-default font-bold text-4xl md:text-5xl leading-none tabular-nums transition-colors duration-300 text-foreground group-hover:text-primary">
                        {feature.number}
                      </span>
                    </div>

                    {}
                    <div className="self-stretch w-px shrink-0 bg-primary" aria-hidden="true" />

                    {}
                    <div className="flex-1 min-w-0">
                      <h3 className="font-default text-sm md:text-base font-semibold tracking-[0.15em] uppercase text-foreground mb-2">
                        {feature.title}
                      </h3>
                      <p className="font-default text-sm md:text-base text-muted-foreground leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                  <Separator className="bg-border" />
                </div>)}
            </div>

            {}
            <div className="mt-10 flex items-center gap-3">
              <span className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground">
                DADE • BROWARD • WEST PALM
              </span>
              <span className="flex-1 h-px bg-border" />
              <span className="font-mono text-xs tracking-[0.2em] uppercase text-primary">
                (561) 560-MOLD
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}